var _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Path, Circle } from "react-native-svg";
function SvgIconChatWhite(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    strokeWidth: 1.2,
    stroke: "#FFF"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    transform: "translate(1 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M11.5 0C17.851 0 23 5.149 23 11.5S17.851 23 11.5 23c-2.196 0-4.249-.616-5.994-1.684l-.014.01c-1.947 1.325-5.514 1-5.492.905 1.395-.745 2.318-1.95 2.77-3.612l-.08.273A11.453 11.453 0 010 11.5C0 5.149 5.15 0 11.5 0z"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 11.5,
    cy: 11.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 6.5,
    cy: 11.5,
    r: 0.6
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 16.5,
    cy: 11.5,
    r: 0.6
  }))));
}
export default SvgIconChatWhite;